<template>
  <div class="personalReportList">
    <div class="title">
      <div class="mainTitle">
        查验申请
        <Guide />
        <!-- <span class="guide" @click="dialogGuide = true"
          ><i class="ico_guide">?</i>新手引导</span
        > -->
      </div>
      <!-- <button class="btn_default">+生成个人信息报告</button> -->
    </div>
    <PageDescription position="reportCheckList" />
    <QA position="reportCheckList" />
    <div class="btns">
      <div class="base">
        <button
          class="btn_noVip_button"
          type="button"
          v-if="list.length > 0"
          @click="isMutiple = !isMutiple"
        >
          {{ isMutiple ? "退出批量处理" : "批量处理" }}
        </button>
        <button class="btn_vip_setOpt" type="button" @click="handleDefault">
          <i class="btn_icon_vip" />设置默认操作
        </button>
      </div>
      <div class="upgrade" v-if="isMutiple">
        <button type="button" class="btn_agree" @click="handleMutipleAgree">
          同意并去选择报告
        </button>
        <button type="button" class="btn_reject" @click="handleMutipleReject">
          拒绝
        </button>
      </div>
    </div>
    <el-table
      empty-text=" "
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="isMutiple"
        type="selection"
        width="55"
        :ame="index"
        :selectable="checkSelect"
      >
      </el-table-column>
      <el-table-column label="申请时间" min-width="60px" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="100px" align="center">
        <template slot-scope="scope">
          <span
            :style="`color:${scope.row.status === 'WAIT' ? '#FF2A00' : '#000'}`"
            >{{ scope.row.status | statusFilter }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160px" align="center">
        <template slot-scope="scope">
          <div style="display:flex;flex-direction: column;">
            <span
              class="detail"
              @click="handleAuth(scope.row)"
              v-if="scope.row.status === 'WAIT'"
              >去授权</span
            >
            <span
              @click="handleCheckAuthReport(scope.row.reportId)"
              class="detail"
              v-if="scope.row.status === 'AGREE'"
              >查看授权报告</span
            >
            <span class="detail" @click="handleCheckOther(scope.row)"
              >查验对方</span
            >
            <span class="detail" @click="commingSoon">在线沟通</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <no-data v-if="list.length === 0" top="-40px" />
    <CommingSoon ref="commingSoon" />
    <!-- <Cover
      :dialogGuide="dialogGuide"
      @dialogGuideClose="handleDialogGuideClose"
    >
      <ul slot="content">
        <li>
          <div>查验申请：</div>
          <div>
            他人通过您的姓名、手机号发起实名查验申请，您可以自行抉择同意授权或拒绝。
          </div>
        </li>
        <li>
          <div>同意授权;</div>
          <div>
            您同意并选择一份个人信息报告（或生成一份新的个人信息报告）授权对方查看。
          </div>
        </li>
        <li>
          <div>拒绝授权：</div>
          <div>
            您拒绝对方实名查验申请。
          </div>
        </li>
      </ul>
    </Cover> -->

    <div v-if="dialogSetAuth">
      <CoverLayout>
        <div class="setAuth" slot="content">
          <!-- <div class="setAuthClose" @click="dialogSetAuth = false"></div> -->
          <div class="setAuthClose" @click="dialogSetAuth = false"></div>
          <div class="dialogTitle">设置授权</div>
          <div class="tip">
            您同意向申请人{{
              authUsername
            }}授权个人信息报告，请选择您授权的报告：
          </div>
          <el-form>
            <el-form-item label="选择报告：">
              <div style="display:flex;flex-direction: column;">
                <el-select
                  v-model="authForm.reportId"
                  placeholder="请选择已有报告"
                  style="width:320px"
                >
                  <el-option
                    v-for="item in reportList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                    >{{ item.name }}</el-option
                  >
                </el-select>
                <span
                  class="addNewReport"
                  @click="
                    $router.push({
                      path: '/personal/index',
                      query: { isSelect: true }
                    })
                  "
                  >+生成新的报告</span
                >
              </div>
            </el-form-item>
            <el-form-item label="授权期限：">
              <div style="display:flex">
                <el-datePicker
                  v-model="authForm.endDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  placeholder="结束时间"
                  style="width:320px"
                ></el-datePicker>
              </div>
            </el-form-item>
          </el-form>
          <div style="text-align:center">
            <button
              type="button"
              class="btn_confirmAuth"
              @click="handleSubmitAuthForm"
            >
              确认授权
            </button>
          </div>
        </div>
      </CoverLayout>
    </div>

    <div v-if="dialogAuthSuccess">
      <CoverLayout>
        <div class="authSuccess" slot="content">
          <div class="dialogIcon_success"></div>
          <div class="dialogTitle">授权成功！</div>
          <div class="dialogContent">
            {{
              userInfo.status === "4"
                ? "您是尊贵的年费用户，可以设置默认的应答模式，是否现在设置？"
                : "邀请您成为年费用户，您可以享受快捷授权，一键就搞定！"
            }}
          </div>
          <div class="authSuccess_btns" v-if="userInfo.status === '4'">
            <button
              type="button"
              class="btn_noSet"
              @click="dialogAuthSuccess = false"
            >
              暂不设置
            </button>
            <button type="button" class="btn_set" @click="handleDefault">
              立即设置
            </button>
          </div>
          <div class="aboutMember" v-else>
            <Btn
              btnText="更多权益了解一下"
              className="primary"
              :width="185"
              @handleClick="handleMore"
            />
            <span
              style="color:#6E6E6E;margin-top:15px"
              @click="dialogAuthSuccess = false"
              >暂不了解</span
            >
          </div>
        </div>
      </CoverLayout>
    </div>

    <div v-if="dialogNoRealNameCertification">
      <CoverLayout>
        <div class="noRealNameCertification" slot="content">
          <div class="noRealNameCertificationTop">
            <div class="pic"></div>
          </div>
          <div class="noRealNameCertificationBottom">
            <div>
              完成实名认证后，您可以任意勾选内容生成个人信息报告
            </div>
            <div class="noRealNameCertificationBtns">
              <button
                type="button"
                class="btn_goCertification"
                @click="handleRealNameAuthentication"
              >
                立即实名认证
              </button>
              <span
                class="btn_noCertification"
                @click="dialogNoRealNameCertification = false"
                >暂不认证，全选所有信息直接授权</span
              >
            </div>
          </div>
        </div>
      </CoverLayout>
    </div>

    <div v-if="dialogConfirm">
      <CoverLayout>
        <div class="noRealNameCertification" slot="content">
          <i class="icon_close" @click="dialogConfirm = false" />
          <div class="noRealNameCertificationTop">
            <div class="pic"></div>
          </div>
          <div class="noRealNameCertificationBottom">
            <div style="line-height: 30px;">
              用户{{
                authUsername
              }}实名向您发起查验申请，您同意后可授权其查验您的个人信息报告。是否同意授权：
            </div>
            <div class="confirmBtns">
              <div @click="handleConfirm(true)">
                <i class="icon_agree" /> 同意
              </div>
              <div @click="handleConfirm(false)">
                <i class="icon_refuse" />拒绝
              </div>
            </div>
          </div>
        </div>
      </CoverLayout>
    </div>

    <div v-if="dialogPaymember">
      <BuyMember
        @handleClose="dialogPaymemberClose"
        subTitle="您正在设置查验应答默认模板，立刻开通年费会员，享受更多专属权益"
      >
        <div slot="btn" style="text-align:center">
          <Btn
            btnText="支付完成"
            @handleClick="handlePayDone"
            className="primary"
            :width="120"
            style="margin-top:30px"
          />
        </div>
      </BuyMember>
    </div>
  </div>
</template>

<script>
import Cover from "@/components/Cover.vue";
// import Confirm from "@/components/Confirm.vue";
import CoverLayout from "../../../components/CoverLayout.vue";
import { reportList, waitDeal } from "@/api/report";
import { inspectionList, inspectedPersonDeal } from "@/api/inspection";
import Btn from "../../../components/Btn.vue";
import BuyMember from "../../../components/BuyMember.vue";
import { getUserInfo } from "@/api/user";
import NoData from "../../../components/NoData.vue";
import Guide from "../../../components/Guide.vue";
import CommingSoon from "../../../components/CommingSoon.vue";
import PageDescription from "../../../components/PageDescription.vue";
import QA from "../../../components/QA.vue";
export default {
  components: {
    Cover,
    CoverLayout,
    Btn,
    BuyMember,
    NoData,
    Guide,
    CommingSoon,
    PageDescription,
    QA
  },

  filters: {
    statusFilter(status) {
      const statusMap = {
        WAIT: "待处理",
        AGREE: "已同意",
        REFUSE: "已拒绝",
        AGREE_TIME_OUT: "已失效"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: [],
      dialogGuide: false,
      listLoading: false,
      dialogConfirm: false,
      isMutiple: false,
      dialogSetAuth: false,
      dialogAuthSuccess: false,
      dialogNoRealNameCertification: false,
      listQuery: {
        current: 1,
        size: 100
      },
      list: [],
      multipleSelection: [],
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      reportList: [],
      authUsername: undefined,
      authForm: {
        agree: false,
        endDate: undefined,
        ids: [],
        reportId: ""
      },
      dialogAuthConfirm: false,
      dialogPaymember: false,
      isBuilding: false
    };
  },
  created() {
    this.getList();
    this.getReportList();
  },
  methods: {
    getList() {
      inspectionList(this.listQuery).then(res => {
        this.list = res.data.d.records;
        this.getWaitDeal();
      });
    },
    getWaitDeal() {
      waitDeal().then(res => {
        this.$emit("redDotChange", res.data.d);
      });
    },
    async getReportList() {
      await reportList({ size: 999, current: 1 }).then(res => {
        this.reportList = res.data.d.records;
      });
    },
    handleAuth(row) {
      // console.log(row);
      this.authForm.ids = [];
      if (this.userInfo.status === "4" || this.userInfo.status === "3") {
        this.authUsername = row.name;
        this.authForm.reportId = row.reportId;
        this.dialogConfirm = true;
        this.authForm.ids.push(row.id);
      } else {
        this.dialogNoRealNameCertification = true;
      }
    },
    // handleDialogGuideClose() {
    //   this.dialogGuide = !this.dialogGuide;
    // },
    handleCredentials() {
      this.$router.push("credentialsList");
    },
    handleCheckOther(row) {
      localStorage.setItem(
        "checkOtherInfo",
        JSON.stringify({ name: row.name, phone: row.phone })
      );
      this.$router.push("/personal/checkOthers/index");
    },
    handleConfirm(data) {
      if (data) {
        this.authForm.agree = data;
        this.dialogSetAuth = true;
        this.dialogConfirm = false;
      } else {
        this.dialogConfirm = false;
        this.authForm.agree = false;
        delete this.authForm.endDate;
        delete this.authForm.reportId;
        inspectedPersonDeal(this.authForm).then(res => {
          if (res.data.c === 200) {
            this.dialogAuthSuccess = true;
            this.getList();
          }
        });
      }
    },

    handleDefault() {
      if (this.userInfo.status === "4") {
        this.$router.push("/personal/reportCheck/authReportDetail");
      } else {
        this.dialogPaymember = true;
      }
      // this.isMutiple = true;
    },
    handlePayDone() {
      getUserInfo().then(res => {
        if (res.data.c === 200) {
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
          this.userInfo = res.data.d;
          this.dialogPaymember = false;
        }
      });
    },
    handleMutipleAgree() {
      if (!this.multipleSelection.length > 0) {
        this.$message.error("请选择需要批量操作的的申请");
        return false;
      }
      this.authForm = {
        ids: this.multipleSelection.map(item => item.id),
        reportId: undefined,
        agree: true,
        endDate: undefined
      };
      this.dialogSetAuth = true;
    },
    handleMutipleReject() {
      this.authForm = {
        ids: this.multipleSelection.map(item => item.id),
        // reportId: undefined,
        agree: false
        // endDate: undefined
      };
      // this.dialogSetAuth = true;
      inspectedPersonDeal(this.authForm).then(res => {
        if (res.data.c === 200) {
          this.dialogAuthSuccess = true;
          this.dialogSetAuth = false;
          this.isMutiple = false;
          this.getList();
        }
      });
    },
    handleRealNameAuthentication() {
      this.$router.push("/personal/realNameAuthentication");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSubmitAuthForm() {
      let tempData = Object.assign({}, this.authForm);
      // tempData.endDate = (this.authForm.endDate / 1000).toString();
      // tempData.endDate = this.authForm.endDate / 1000;
      const timestamp = 24 * 60 * 60 * 1000 - 1;
      tempData.endDate = Math.floor((this.authForm.endDate + timestamp) / 1000);

      inspectedPersonDeal(tempData).then(res => {
        if (res.data.c === 200) {
          this.dialogAuthSuccess = true;
          this.dialogSetAuth = false;
          this.getList();
        }
      });
    },
    handleCheckAuthReport(id) {
      console.log("handleCheckAuthReport");
      this.$router.push({
        path: "/reportPreview",
        query: { id, type: 1, active: 2 }
      });
    },
    dialogPaymemberClose() {
      this.dialogPaymember = false;
    },
    checkSelect(row, index) {
      return row.status === "WAIT";
    },
    handleMore() {
      this.dialogPaymember = true;
      this.dialogAuthSuccess = false;
    },
    commingSoon() {
      this.$refs.commingSoon.handleShow();
    }
  }
};
</script>

<style lang="scss" scoped>
.personalReportList {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  >>> .el-table th.el-table__cell {
    background-color: #f0f2f5;
  }
  >>> .el-table {
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    .mainTitle {
      display: flex;
      align-items: center;
      &::before {
        content: "";
        border-left: 3px solid #3a61b1;
        padding-right: 10px;
        height: 16px;
        position: relative;
        top: 0px;
      }
      .guide {
        font-size: 14px;
        font-weight: normal;
        color: #6e6e6e;
        display: flex;
        align-items: center;
        .ico_guide {
          background: #ff8d65;
          width: 15px;
          height: 15px;
          display: inline-block;
          border-radius: 15px;
          margin-right: 5px;
          margin-left: 12px;
          font-style: normal;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
  .btns {
    display: flex;
    justify-content: space-between;
    .base {
      .btn_vip_setOpt {
        width: 138px;
        height: 41px;
        border-radius: 20.5px;
        margin-bottom: 23px;
        margin-right: 17px;
        cursor: pointer;
        color: #653e12;
        background: #e5c7a3;
        border: 0;
      }
      .btn_noVip_button {
        border: 1px solid #3a61b1 !important;
        border: 0;
        background: #fff;
        color: #3a61b1;
        width: 119px;
        height: 41px;
        border-radius: 20.5px;
        margin-bottom: 23px;
        margin-right: 17px;
        cursor: pointer;
      }
    }
    .upgrade {
      button {
        height: 41px;
        color: #fff;
        border-radius: 20.5px;
        margin-left: 16px;
        border: 0;
        cursor: pointer;
      }
      .btn_agree {
        background: #50d6a5;
        width: 141px;
      }
      .btn_reject {
        width: 81.5px;
        background: #ff7c66;
      }
    }
  }
  .detail {
    color: #338ff7;
    cursor: pointer;
  }
  .btn_default {
    width: 165px;
    height: 39px;
    border: 1px solid #ddd;
    border-radius: 19.5px;
    background: #fff;
  }

  .coverLayout {
    .setAuth {
      width: 504px;
      box-sizing: border-box;
      padding: 32px 53px 56px 38px;
      background: #fff;
      border-radius: 16px;
      position: relative;
      .setAuthClose {
        position: absolute;
        right: 20px;
        top: 20px;
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_fileRemove.png")
          no-repeat;
        background-size: cover;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      .dialogTitle {
        text-align: center;
        font-size: 20px;
        margin-bottom: 47px;
      }
      .tip {
        font-size: 18px;
        margin-bottom: 35px;
      }
    }
    .addNewReport {
      color: #3a61b1;
    }
    .btn_confirmAuth {
      width: 155px;
      height: 41px;
      background: #3a61b1;
      border-radius: 21px;
      font-size: 16px;
      color: #fff;
      border: 0;
    }
  }
  .authSuccess {
    padding: 73px 68px 69px 54px;
    width: 504px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: space-between;
    .dialogIcon_success {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/success.png")
        no-repeat;
      width: 75px;
      height: 97px;
      background-size: cover;
    }
    .dialogTitle {
      font-size: 24px;
      color: #6e6e6e;
      margin-bottom: 25px;
      text-align: center;
    }
    .dialogContent {
      color: #6e6e6e;
      font-size: 18px;
      text-align: center;
    }
    .aboutMember {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 15px;
    }
    .authSuccess_btns {
      margin-top: 39px;
      display: flex;
      justify-content: space-around;
      button {
        width: 155px;
        height: 41px;
        font-size: 16px;
        border-radius: 21px;
      }
      .btn_noSet {
        border: 1px solid #3a61b1;
        background: #ffffff;
        color: #3a61b1;
      }
      .btn_set {
        margin-left: 27px;
        background: #3a61b1;
        color: #fff;
        border: 0;
      }
    }
  }
  .noRealNameCertification {
    width: 504px;
    position: relative;
    .icon_close {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_close.png")
        no-repeat;
      background-size: cover;
      width: 15px;
      height: 15px;
      display: inline-block;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .noRealNameCertificationTop {
      background: #f2f6fe;
      //   border-radius-lef: 16px;
      height: 221px;
      border-radius: 16px 16px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .pic {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/rc1.png")
          no-repeat;
        background-size: cover;
        width: 199px;
        height: 137px;
      }
    }
    .noRealNameCertificationBottom {
      background: #fff;
      padding: 42px 45px 59px 45px;
      border-radius: 0 0 16px 16px;
      color: #6e6e6e;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      text-align: center;
      .noRealNameCertificationBtns {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 36px;
        .btn_goCertification {
          width: 174px;
          height: 41px;
          background: #3a61b1;
          border-radius: 21px;
          color: #fff;
          border: 0;
          margin-bottom: 16px;
        }
        .btn_noCertification {
          color: #b3b3b3;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .confirmBtns {
        display: flex;
        flex-direction: row;
        align-items: center;
        // justify-content: center;
        justify-content: space-around;
        margin-top: 36px;
        .icon_agree {
          width: 26px;
          height: 18px;
          display: inline-block;
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/agree.png")
            no-repeat;
          background-size: cover;
          margin-right: 10px;
        }
        .icon_refuse {
          width: 26px;
          height: 18px;
          display: inline-block;
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/refuse.png")
            no-repeat;
          background-size: cover;
          margin-right: 10px;
        }
        div {
          cursor: pointer;
          font-size: 14px;
          color: #6e6e6e;
          display: flex;
          align-items: center;
        }
        // .btn_goCertification {
        //   width: 174px;
        //   height: 41px;
        //   background: #3a61b1;
        //   border-radius: 21px;
        //   color: #fff;
        //   border: 0;
        //   margin-bottom: 16px;
        // }
        // .btn_noCertification {
        //   color: #b3b3b3;
        //   cursor: pointer;
        //   font-size: 14px;
        // }
      }
    }
  }
  .btn_icon_vip {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/btn_icon_vip.png");
    background-size: cover;
    width: 20px;
    height: 15px;
    display: inline-block;
    margin-right: 3px;
  }
}
>>> .el-table::before {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/personal/reportCheck/list.vue